import { UseCustomAxios } from "../../../UseCustomAxios";
import { useSnackbar } from "notistack";
import { isEmpty } from "../../../util/Utils";

export function UseLandingHeader() {
  const MyAxios = UseCustomAxios();
  const { enqueueSnackbar } = useSnackbar();

  function validate(state, imgState, setter) {
    let errorState = {
      title: isEmpty(state.title),
      url: isEmpty(state.url),
      file1: isEmpty(imgState.url1),
      file2: isEmpty(imgState.url2),
    };

    setter(errorState);

    if (errorState.title || errorState.url) {
      enqueueSnackbar("لطفا اطلاعات هدر را کامل وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    } else {
      return 200;
    }
  }

  const GetHeader = (landingID, callback) => {
    MyAxios.get(`/Admin_LandingPages/GetHeader/${landingID}`).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          callback(response.data.resault);
        }
      }
    );
  };

  const SetHeader = (state, logo1, logo2, logo3, callback) => {
    const data = new FormData();
    data.append("Content", JSON.stringify(state));
    if (logo1) {
      data.append("logo1", logo1);
    }
    if (logo2) {
      data.append("logo2", logo2);
    }
    if (logo3) {
      data.append("logo3", logo3);
    }
    MyAxios.post(`Admin_LandingPages/SetHeader`, data).then((response) => {
      if (response && response.data && response.data.state == 200) {
        enqueueSnackbar("محتوای هدر با موفقیت تنظیم شد", {
          variant: "success",
          autoHideDuration: 2000,
          preventDuplicate: true,
        });
        callback();
      }
    });
  };

  const RemoveHeader = (ID, callback) => {
    const data = new FormData();
    data.append("ID", ID);
    MyAxios.delete(`Admin_LandingPages/RemoveHeader`, { data: data }).then(
      (response) => {
        if (response && response.data && response.data.state == 200) {
          enqueueSnackbar("کامپوننت با موفقیت حذف شد", {
            variant: "success",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
          callback();
        }
      }
    );
  };

  return {
    validate,
    GetHeader,
    SetHeader,
    RemoveHeader,
  };
}
